import { ForeAftEnum, LcgReferenceEnum, PortStarboardEnum, ValuesSourceEnum, ValuesSourceRowTierEnum, ovdV1ToStafConverter, } from "open-vessel-definition";
import UoLcgReferenceEnum from "../../../../../../../app/enums/UoLcgReferenceEnum";
import VcgVerticalReferenceEnum from "../../../../../../../app/enums/VcgVerticalReferenceEnum";
export function createStafFile(json, exportStafOptions) {
    var _a, _b, _c, _d, _e, _f, _g;
    //Do conversion here and resolve with STAF file converted
    const stafFile = ovdV1ToStafConverter(json, {
        cgOptions: {
            lcgOptions: {
                reference: exportStafOptions.lcgRef === UoLcgReferenceEnum.AFT_PERPENDICULAR_DFWD
                    ? LcgReferenceEnum.AFT_PERPENDICULAR
                    : exportStafOptions.lcgRef === UoLcgReferenceEnum.FWD_PERPENDICULAR_DAFT
                        ? LcgReferenceEnum.FWD_PERPENDICULAR
                        : LcgReferenceEnum.MIDSHIPS,
                orientationIncrease: exportStafOptions.lcgRef === UoLcgReferenceEnum.AFT_PERPENDICULAR_DFWD
                    ? ForeAftEnum.FWD
                    : exportStafOptions.lcgRef === UoLcgReferenceEnum.FWD_PERPENDICULAR_DAFT
                        ? ForeAftEnum.AFT
                        : exportStafOptions.lcgRef === UoLcgReferenceEnum.MIDSHIPS_DFWD
                            ? ForeAftEnum.FWD
                            : ForeAftEnum.AFT,
                lpp: ((_b = (_a = json.shipData) === null || _a === void 0 ? void 0 : _a.lcgOptions) === null || _b === void 0 ? void 0 : _b.lpp) || 0,
                values: ((_c = json.shipData) === null || _c === void 0 ? void 0 : _c.lcgOptions.values) || ValuesSourceEnum.ESTIMATED,
            },
            vcgOptions: {
                values: ((_d = json.shipData) === null || _d === void 0 ? void 0 : _d.vcgOptions.values) === ValuesSourceEnum.ESTIMATED
                    ? ValuesSourceRowTierEnum.ESTIMATED
                    : ValuesSourceRowTierEnum.BY_STACK,
                heightFactor: exportStafOptions.vcgRef === VcgVerticalReferenceEnum.VCG_45_8_6
                    ? 0.45
                    : exportStafOptions.vcgRef === VcgVerticalReferenceEnum.VCG_50_8_6
                        ? 0.5
                        : 0,
            },
            tcgOptions: {
                values: ((_e = json.shipData) === null || _e === void 0 ? void 0 : _e.tcgOptions.values) || ValuesSourceEnum.ESTIMATED,
                direction: exportStafOptions.tcgRef || PortStarboardEnum.STARBOARD,
            },
        },
        tier82is: exportStafOptions.tier82is || 82,
        removeBaysWithNonSizeSlots: exportStafOptions.removeBaysWithNonSizeSlots,
        removeCGs: exportStafOptions.addRemoveCgs === "remove",
        removeBelowTiers24AndHigher: (_f = exportStafOptions.remove24s) !== null && _f !== void 0 ? _f : false,
        remove100s: (_g = exportStafOptions.remove100s) !== null && _g !== void 0 ? _g : false,
    });
    return stafFile;
}
